import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MultiSelectItem } from '@usitsdasdesign/dds-ng/multi-select';
import { VirtualOptions } from 'src/app/models/meetings.model';
import { DataContextService } from 'src/app/services/datacontext.service';
import { AdditionalDetailscategory } from '../../models/masterdata.model';

@Component({
  selector: 'app-virtul-options',
  templateUrl: './virtul-options.component.html',
  styleUrls: ['./virtul-options.component.less'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => VirtulOptionsComponent),
    multi: true
  }]
})
export class VirtulOptionsComponent implements OnInit, ControlValueAccessor {
  accordionlength = [1]
  @Input() Id = [];
  @Output() selectedItems: EventEmitter<(string | number)[]> = new EventEmitter();
  virtualOptions: VirtualOptions[] =[];
  virtualOptionsBR: VirtualOptions;
  form = new FormGroup({
    radio: new FormControl(),
  });

  onChange: any = () => {
  }
  onTouch: any = () => {
  }
  count: Number;
  constructor() { }

  ngOnInit(): void {
    this.count = this.Id.length;
    DataContextService.VirtualBookingAdditionalDetails.forEach((obj) => {
      if (obj.category.id != AdditionalDetailscategory.breakoutRooms)
        this.virtualOptions.push(
          {
            category: obj.category.name,
            categoryId: obj.category.id,
            additionalDetails: this.mapOptions(obj.virtualBookingAdditionalDetails, obj.category.id) as MultiSelectItem[]
          }
        );
      else
        this.virtualOptionsBR = {
          category: obj.category.name,
          categoryId: obj.category.id,
          additionalDetails: this.mapOptions(obj.virtualBookingAdditionalDetails, obj.category.id) as MultiSelectItem[]
        }
    });

  }
  mapOptions(data, id) {
    let virtualOptions = [];
    data.forEach(i => {
      virtualOptions.push({
        label: i.description,
        id: i.id.toString(),
        isChecked: this.Id ? this.Id.some((type) => type == i.id) : false,
      })
    })
    if (virtualOptions) {
      if (id == 4 && this.Id.length) {
        const selectedRadio = virtualOptions.filter(item => this.Id.includes(Number(item.id)))
        if (selectedRadio.length) {
          this.form.controls.radio.setValue(selectedRadio[0].id);
        }
      }
      return virtualOptions;
    }

  }
  changeItem(event, addId) {
    if (event) {
      this.Id.push(Number(addId))
    }
    else {
      const index = this.Id.findIndex((i) => i == Number(addId));
      this.Id.splice(index, 1)
    }
    this.count = this.Id.length;
    this.selectedItems.emit(this.Id);
  }

  stateChanged(event) {
    const record = this.virtualOptionsBR.additionalDetails.filter(i => this.Id.includes(Number(i.id)))
    if (record.length) {
      this.Id.splice(this.Id.findIndex((i) => i == Number(record[0].id)), 1)
    }
    this.Id.push(Number(event));
    this.count = this.Id.length;
    this.selectedItems.emit(this.Id);
  }
  writeValue(value: any) { }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
  clearSeaction() {
    this.form.controls.radio.setValue(null);
    const record = this.virtualOptionsBR.additionalDetails.filter(i => this.Id.includes(Number(i.id)))
    if (record.length) {
      this.Id.splice(this.Id.findIndex((i) => i == Number(record[0].id)), 1)
    }
    this.count = this.Id.length;
    this.selectedItems.emit(this.Id);
  }
}

// export interface VirtualOptions{
//   isCheckBox:boolean ;
//   category:string;
//   categoryId:number;
//   additionalDetails:MultiSelectItem[];
// }
